var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5C3.5 7.20017 3.5 5.55025 4.52513 4.52513C5.55025 3.5 7.20017 3.5 10.5 3.5H17.5C20.7998 3.5 22.4497 3.5 23.4749 4.52513C24.5 5.55025 24.5 7.20017 24.5 10.5V16.3333C24.5 18.5332 24.5 19.6332 23.8166 20.3166C23.1332 21 22.0332 21 19.8333 21H8.16667C5.96678 21 4.86684 21 4.18342 20.3166C3.5 19.6332 3.5 18.5332 3.5 16.3333V10.5Z",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.6666 24.5H2.33325",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5 17.5H10.5",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwaIcon);
export default __webpack_public_path__ + "static/media/pwaIcon.5306980f2211f849bf66a139c4367db0.svg";
export { ForwardRef as ReactComponent };